// removed by extract-text-webpack-plugin
module.exports = {"container":"_2ub8wKGILF1Kv1TYBdDCOu","icon":"_3fC9I1idPRGKXKnY6v8ngx","title":"_9KElHSgsAMXmBr12Hyu0i","Email":"_3UGuTQHLrXjszLVHwWU3xx","Signer":"FDkSxcjnWdYE3sCmu2KG1"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Signers/styles.css
// module id = 2846
// module chunks = 0